import { emptyFragment } from '@execonline-inc/execonline-ui';
import { Maybe } from 'maybeasy';
import { observer } from 'mobx-react';
import { T, TPlainTextKey } from '../../../../Translations';
import WarningTriangleIcon from './Cutsies/WarningTriangleIcon';

interface ErrorMessageProps {
  error: Maybe<TPlainTextKey>;
}

function ErrorMessage({ error }: ErrorMessageProps) {
  return error
    .map((translationKey) => (
      <div className="flex items-center gap-2 mt-1">
        <WarningTriangleIcon />
        <p className="text-destructive text-sm">
          <T kind={translationKey} />
        </p>
      </div>
    ))
    .getOrElse(emptyFragment);
}

export default observer(ErrorMessage);
